"use client";

// Formularz logowania = natywny POST do akcji serwerowej (bez next-auth/react).
// Działa także tam, gdzie skrypt w przeglądarce nie rusza (skaner kolektora,
// operator 8–9.09.2026). `useFormStatus` tylko podświetla „Logowanie…".

import { useFormStatus } from "react-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { zalogujAction } from "./actions";

function Przycisk() {
  const { pending } = useFormStatus();
  return (
    <Button type="submit" disabled={pending} className="mt-2">
      {pending ? "Logowanie..." : "Zaloguj się"}
    </Button>
  );
}

export function LoginForm({ blad }: { blad?: string | null }) {
  const komunikat =
    blad === "dane" ? "Nieprawidłowy email lub hasło" : blad === "puste" ? "Wpisz email i hasło" : blad ? "Nie udało się zalogować — spróbuj ponownie" : null;
  return (
    <form action={zalogujAction} method="post" className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="email">Email</Label>
        <Input id="email" name="email" type="email" autoComplete="email" required autoFocus />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label htmlFor="password">Hasło</Label>
        <Input id="password" name="password" type="password" autoComplete="current-password" required />
      </div>
      {komunikat ? <p className="-mt-1 text-sm text-red-600">{komunikat}</p> : null}
      <Przycisk />
    </form>
  );
}
